import React from "react";
import { useTranslation } from 'react-i18next';

export default function PriceWithUnitShow({ id }) {
  const { t } = useTranslation();
  return (
    <span>
      {`${t(id)} (${t("moneyUnit")}`})
    </span>
  )
}